import bootbox from 'bootbox';

import { api } from 'JIX/utils.js';
import getToastManager from 'JIX/ui/toasts.js';
import { __ } from 'JIX/gettext.js';


/**
 * Handle opening the contact form modal
 *
 * @param {HTMLElement} btn The button clicked
 */
function handleOpenContactModal(btn) {

    const btnURL = new URL(btn.href);
    const ref = btnURL.searchParams.get('ref');

    const formTemplate = document.getElementById('companyuser-contact-template');
    /** @type {Node[]} */
    const formContent = formTemplate.content.cloneNode(true);
    const form = document.createElement('form');

    form.append(formContent);

    const submitButton = form.querySelector('.btn');
    submitButton.classList.add('btn-sm', 'd-block', 'ml-auto');

    const $modal = bootbox.dialog({
        title: __('Bliv ringet op'),
        message: form,
        backdrop: true,
    });

    /**
     * @param {SubmitEvent} event
     */
    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            submitButton.disabled = true;
            submitButton.style.cursor = 'wait';

            const data = new FormData(form);
            if (ref) {
                data.set('ref', ref);
            }

            await api('POST', '/virksomhedsbruger/kontakt.json', data, { processData: false, contentType: false });

            $modal.modal('hide');

            getToastManager().createToast({
                title: __('Tak for henvendelsen'),
                message: __('Du hører fra os'),
                autohide: true,
                delay: 9 * 1000,
            }).show();

        } catch (error) {
            submitButton.disabled = false;
            submitButton.style.cursor = null;
            throw error;

        } finally {
            window.jixAnalytics('event', { category: 'kontaktformular', action: 'click', label: 'Bliv ringet op' });
        }
    };

    form.addEventListener('submit', handleSubmit);
}

document.querySelectorAll('.jix-companyuser-contact').forEach((link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        handleOpenContactModal(link);
    });
});
